import { render, staticRenderFns } from "./customFormOther.vue?vue&type=template&id=2dc7b716&scoped=true"
import script from "./customFormOther.vue?vue&type=script&lang=js"
export * from "./customFormOther.vue?vue&type=script&lang=js"
import style0 from "./customFormOther.vue?vue&type=style&index=0&id=2dc7b716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7b716",
  null
  
)

export default component.exports